import React, { Component } from 'react';
import { AuthActions } from 'actions';
import { CircularProgress, Styles } from 'material-ui';

const { Spacing } = Styles;

export default class Logout extends Component {
  componentDidMount() {
    AuthActions.logout();
  }

  render() {
    return (
      <div
        style={{
          textAlign: 'center',
          marginTop: Spacing.desktopKeylineIncrement
        }}
      >
        <CircularProgress mode="indeterminate" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Logout.js